export class BulkActionRequest {
  constructor(
    public bulkActionName: string,
    public imeis: string[],
    public bulkActionType: string,
    public countryCode: string | null,
    public movingIntervalSeconds: number | null,
    public stationaryIntervalSeconds: number | null,
    public gatewayEnvironmentKey: string | null,
    public tenantId: string | null,
    public connectorIds: string[],
    public groupId: string | null,
  ) {
  }
}
